import SetPasswordPage from './components/SetPasswordPage';

export default SetPasswordPage;
